import { render, staticRenderFns } from "./AuthorTop.vue?vue&type=template&id=0a811fd3&scoped=true"
import script from "./AuthorTop.vue?vue&type=script&lang=js"
export * from "./AuthorTop.vue?vue&type=script&lang=js"
import style0 from "./AuthorTop.vue?vue&type=style&index=0&id=0a811fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a811fd3",
  null
  
)

export default component.exports